import { Component } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-emoji-picker",
  templateUrl: "./emoji-picker.page.html",
})
export class EmojiPickerPage {
  public readonly emojiPickerI18n = this.i18n.instant("EMOJI_PICKER");

  constructor(private readonly modalController: ModalController, private readonly i18n: TranslateService) {}

  public emojiSelect(event: any): void {
    this.modalController.dismiss(event.emoji);
  }
}
